import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const LoadPictureHospital = (hospitalData) => {

    const [data, setData] = useState(null);

    const getData = useCallback(() => {

        if (hospitalData === null) {

            setData(null)

        }

        if (hospitalData?.hcode !== undefined) {
            axios({
                method: 'get',
                url: `https://script.google.com/macros/s/AKfycbwAMX25yxw_aksB3VkTlN_pbn4_oj0WD861BZtnz810kMql9IyXieflQ36Ofm58CPjnoA/exec?id=2&hcode=${hospitalData?.hcode}`,
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then((res) => {

                    if (res.data && res.data) {

                        setData(res.data);

                    }

                })
                .catch((error) => {

                    setData([])

                })
        }

    }, [hospitalData])

    useEffect(() => {

        getData();

    }, [getData]);

    return data;

}

export default LoadPictureHospital
